export const getResetOverrideConfirmationDescription = name =>
  `This will discard your company's changes to ${name}. The Global version will be used. Continue?`;

export const GLOBAL_FORM_REPLACE_WARNING =
  'This is a global form: the change applies to every company that has not overridden it.';

export const ReplaceContentResetMessage = {
  NEW_PDF:
    'The current PDF will be replaced. Its field bindings, groups and dependencies will be reset.',
  PDF_TO_EMPTY_HTML:
    'The form will be switched to an empty HTML template. The PDF field bindings, groups and dependencies will be reset.',
  EMPTY_HTML: 'The current HTML template will be cleared.',
};

export const ContentActionText = {
  OVERRIDE: 'Override',
  REPLACE: 'Replace',
  SAVE: 'Save',
};

export const REPLACE_CONTENT_CONFIRMATION_TITLE = 'Replace form content';

export const REPLACE_CONTENT_CONFIRMATION_QUESTION = 'Continue?';
